import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { CollapseContentData } from '../types'

interface Props {
  collapseContentData: CollapseContentData
}

const LeftBlock = ({ collapseContentData }: Props) => {
  return (
    <Box>
      <Text.Normal weight="medium" color="grey1000">
        {i18n.t('dashboard.todo.approvals.attendance.shift_date')}
      </Text.Normal>
      <Text.Normal>
        {dateToString(moment(collapseContentData.date), 'ui_full_month_year')}
      </Text.Normal>
    </Box>
  )
}

export default LeftBlock
